import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';

type Props = TypographyProps<'h1'>;

export default function Heading({
  variant = 'h3',
  color = 'textPrimary',
  ...props
}: Props): JSX.Element {
  return (
    <Typography
      component="h1"
      style={{ textAlign: 'center' }}
      {...{ color, variant }}
      {...props}
    />
  );
}
